import * as React from 'react'
import {Text, TYPOGRAPHY} from 'wix-ui-tpa/Text'
import s from './description.st.css'

export const Description = props => <Text typography={TYPOGRAPHY.runningText} {...props} className={s.root} />
